import { render, staticRenderFns } from "./CustomUiSettings.vue?vue&type=template&id=11e08974&"
import script from "./CustomUiSettings.vue?vue&type=script&lang=ts&"
export * from "./CustomUiSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CustomUiSettings.vue?vue&type=style&index=0&id=11e08974&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports